if (!customElements.get('accordion-item')) {
  customElements.define(
    'accordion-item',
    class AccordionItem extends HTMLElement {
      constructor() {
        super();
        this.summary = this.querySelector('.summary__title');
        this.content = this.querySelector('.accordion__content');
        this._toggle = this._toggle.bind(this);
      }

      connectedCallback() {
        if (this.summary && this.content) {
          this.summary.addEventListener('click', this._toggle);
          if (this.hasAttribute('open')) {
            this._openContent();
          } else {
            this._closeContent();
          }
        }
      }

      disconnectedCallback() {
        if (this.summary) {
          this.summary.removeEventListener('click', this._toggle);
        }
      }

      _toggle() {
        if (this.hasAttribute('open')) {
          this.removeAttribute('open');
          this._closeContent();
        } else {
          this.setAttribute('open', '');
          this._openContent();
        }
      }

      _openContent() {
        const scrollHeight = this.content.scrollHeight;
        this.content.style.height = scrollHeight + 'px';

        const removeHeight = () => {
          this.content.style.height = 'auto';
          this.content.removeEventListener('transitionend', removeHeight);
        };
        this.content.addEventListener('transitionend', removeHeight);
      }

      _closeContent() {
        if (this.content.style.height === 'auto') {
          this.content.style.height = this.content.scrollHeight + 'px';
          this.content.offsetHeight;
        }
        this.content.style.height = '0px';
      }
    }
  );
}
